const getFilteredAndSorted = <S>(items: S[], filterMethod: (value: S, index: number, array: S[]) => unknown, comparatorMethod: (a: S, b: S) => number) => {
  return items.filter(filterMethod)
    .sort(comparatorMethod);
};    
  
export default getFilteredAndSorted;
